import { Icon } from '@eventbrite/eds-icon';
import { LogoEBrand } from '@eventbrite/eds-iconography';
import { ProgressIndicator } from '@eventbrite/eds-progress-indicator';
import React from 'react';
import './FullTakeoverLoadingScreen.scss';

interface FullTakeoverLoadingScreenProps {
    isInBrowser: boolean;
}

export const FullTakeoverLoadingScreen: React.FunctionComponent<
    FullTakeoverLoadingScreenProps
> = ({ isInBrowser, children }) => {
    const [shouldRenderChildren, setShouldRenderChildren] =
        React.useState(false);
    const [renderLoading, setRenderLoading] = React.useState(true);

    React.useEffect(() => {
        let timeoutId: NodeJS.Timeout | undefined;

        if (isInBrowser) {
            setShouldRenderChildren(true);
            timeoutId = setTimeout(() => setRenderLoading(false), 800);
        }

        () => (typeof timeoutId === 'number' ? clearTimeout(timeoutId) : null);
    }, [isInBrowser]);

    return (
        <>
            <div
                className={`loading-state ${
                    !renderLoading ? 'loading-state__fade' : ''
                }`}
            >
                <Icon type={<LogoEBrand />} color="ui-orange" size="medium" />
                <div className="loading-state__progress-indicator">
                    <ProgressIndicator style="gradient" shape="linear" />
                </div>
            </div>
            {shouldRenderChildren ? children : null}
        </>
    );
};
